<template>
  <v-app class="appbg">
    <AppHeader />
    <v-layout>
      <v-flex pt-12>
        <router-view />
      </v-flex>
    </v-layout>
    <AppFooter />
  </v-app>
</template>

<script>
import AppHeader from "./components/Common/AppHeader";
import AppFooter from "./components/Common/AppFooter";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {};
  }
};
</script>
<style>
@font-face {
  font-family: proxima;
  src: url("./assets/fonts/Proxima_Nova_Regular.otf");
}
@font-face {
  font-family: proxima_Bold;
  src: url("./assets/fonts/Proxima_Nova_Bold.otf");
}
@font-face {
  font-family: opensans;
  src: url("./assets/fonts/OpenSans_SemiBold.ttf");
}
@font-face {
  font-family: opensans_Bold;
  src: url("./assets/fonts/OpenSans_Bold.ttf");
}
@font-face {
  font-family: opensans_Regular;
  src: url("./assets/fonts/OpenSans_Regular.ttf");
}
@font-face {
  font-family: montserrat;
  src: url("./assets/fonts/Montserrat_SemiBold.ttf");
}
@font-face {
  font-family: montserrat_Bold;
  src: url("./assets/fonts/Montserrat_Bold.ttf");
}
@font-face {
  font-family: montserrat_Regular;
  src: url("./assets/fonts/Montserrat_Regular.ttf");
}
.color-primary {
  color: #1fb07c !important; /*AppHeader */
}
.color-secondary {
  color: #00a972 !important; /*Home Text*/
}

.v-text-field__slot .v-label {
  font-size: 14px !important;
}
button {
  border-radius: 2px !important;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border: 1px solid #26af82;
  outline: 0;
  border-width: 0 0 2px;
  text-align: "center";
  padding-left: 12px;
}
</style>